module.exports = __webpack_public_path__ + "img/logo.54faa20b.png";